<template>
  <div class="depot">
    <headerNotice routerName="发货点设置"></headerNotice>
    <!-- 发货点列表 -->
    <div class="depot-list">
      <div class="head">
        <h2 class="title">
          <i></i>
          <span>数据列表</span>
        </h2>
        <div class="control">
          <el-button class="tip-box" @click="toAddDepot">添加</el-button>
        </div>
      </div>
      <!-- 收货地址弹出框 -->
      <div class="add-box">
        <el-dialog
          v-loading="loading"
          width="600px"
          :title="dialogTitle"
          :visible.sync="showAddBox"
        >
          <el-form ref="form" :rules="rules" class="from-el" :model="form" label-width="98px">
            <el-form-item prop="deliveryPointName" label="发货点名称:">
              <el-input
                placeholder="请输入发货点名称"
                class="input-el"
                v-model="form.deliveryPointName"
                autocomplete="off"
                maxlength="15"
              ></el-input>
            </el-form-item>
            <el-form-item prop="consignor" label="联系人:">
              <el-input
                placeholder="请输入联系人"
                class="input-el"
                v-model="form.consignor"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="divisionID == 0"
              v-loading="userListLoading"
              prop="userID"
              style="width:80%;"
              label="管理员:"
            >
              <el-select multiple class='input-el' v-model="form.userID" placeholder="请选择管理员">
                <el-option
                  v-for="item in userList"
                  :key="item.userID"
                  :label="item.userName"
                  :value="item.userID"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="phone" label="联系电话:">
              <el-input
                placeholder="请输入联系电话"
                class="input-el"
                v-model="form.phone"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-loading="regionLoading"
              style="width: 80%;"
              prop="areaCode"
              label="发货点地区:"
            >
              <el-cascader
                class="input-el"
                ref="regin"
                @change="setAreaName"
                :options="reginData"
                :props="cascaderProps"
                v-model="form.areaCode"
              ></el-cascader>
            </el-form-item>
            <el-form-item prop="address" label="详细地址:">
              <el-input
                placeholder="请输入详细地址"
                type="textarea"
                resize="none"
                class="input-el"
                v-model="form.address"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="showAddBox = false">取 消</el-button>
            <el-button :loading="btnLoading" type="primary" @click="checkForm">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <!-- 表格 -->
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="depotList"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column align="center" type="index" label="序号" width="55"></el-table-column>
        <el-table-column align="center" prop="deliveryPointName" label="发货点名称"></el-table-column>
        <el-table-column align="center" prop="address" label="发货点地址"></el-table-column>
        <el-table-column align="center" prop="consignor" label="联系人"></el-table-column>
        <el-table-column align="center" prop="phone" label="联系电话"></el-table-column>
        <el-table-column v-if='isAdmin==1' align="center" label="设为默认" width="180">
          <template slot-scope="scope">
            <el-switch
              @change="UpdateDefault(scope.row.deliveryPointID, $event)"
              :active-value="1"
              :inactive-value="0"
              v-model="scope.row.default"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="address" label="操作">
          <template slot-scope="scope">
            <el-button @click="toEditDepot(scope.row)" type="text" size="small">修改</el-button>
            <el-button
              @click="deleteDelivery(scope.row.deliveryPointID)"
              type="text"
              size="small"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";

export default {
  components: {
    headerNotice
  },
  props: {},
  data() {
    var checkTel = (rule, value, callback) => {
      if (!/^1[34578]\d{9}$/.test(value)) {
        return callback(new Error("请输入正确的联系电话"));
      } else {
        callback();
      }
    };
    var checkAreaCodes = (rule, value, callback) => {
      if (!this.$refs.reginTree.getCheckedKeys().length) {
        return callback(new Error("请勾选覆盖地区"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      areaLoading: false,
      regionLoading: false,
      btnLoading: false,
      userListLoading: false,
      iscreat: false,
      pageSize: 10,
      SkipCount: 0,
      totalCount: 0,
      depotList: [],
      dialogTitle: "",
      searchWord: "",
      status: "",
      reginData: [],
      defaultKeys: [],
      defaultProps: {
        children: "children",
        value: "code",
        label: "name"
      },
      cascaderProps: {
        children: "children",
        label: "name",
        value: "code"
      },
      areaTreeKeys: [],
      showAreaBox: false,
      logistics: [],
      userList: [],
      divisionID: 0,
      isAdmin: 0,
      timer: '',
      form: {},
      showAddBox: false,
      options: [
        {
          value: "",
          label: "全部"
        },
        {
          value: 1,
          label: "已启用"
        },
        {
          value: 0,
          label: "已禁用"
        }
      ],
      selections: [],
      rules: {
        deliveryPointName: [
          { required: true, message: "请输入发货点名称", trigger: "blur" }
        ],
        houseCode: [
          { required: true, message: "请输入发货点编号", trigger: "blur" }
        ],
        address: [
          { required: true, message: "请输入发货点地址", trigger: "blur" }
        ],
        consignor: [
          { required: true, message: "请输入联系人", trigger: "blur" }
        ],
        userID: [{required: true, message: "请选择管理员", trigger: "blur"}],
        phone: [{ required: true, validator: checkTel, trigger: "blur" }],
        logisticsID: [
          { required: true, message: "请选择快递公司", trigger: "blur" }
        ],
        areaCodes: [
          { required: true, validator: checkAreaCodes, trigger: "blur" }
        ],
        areaCode: [
          { required: true, message: "请选择发货点地区", trigger: "blur" }
        ]
      }
    };
  },
  watch: {
    showAddBox(val) {
      if (!val) {
        if(this.timer) {
          clearTimeout(this.timer)
        }
        setTimeout(() => {
          this.form = {
            deliveryPointName: '',
            address: '',
            consignor: '',
            userID: [],
            phone: '',
            areaCode: []
          }
          this.timer = this.$refs.form.resetFields();
        }, 20)
        // this.defaultKeys = [];
        // this.$refs.reginTree.setCheckedKeys([]);
      }
    }
  },
  computed: {},
  methods: {
    setAreaName() {
      var name = this.$refs.regin.currentLabels;
      this.form.provinceName = name[0];
      this.form.cityName = name[1];
      this.form.areaName = name[2];
    },
    // 修改默认状态
    UpdateDefault(id, status) {
      let self = this;
      $http.PUT({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminIntegralExchange/UpdateDefault",
        data: {
          deliveryPointID: id,
          default: status
        },
        success(res) {
          self.$message.success("操作成功");
          self.toSearch();
        },
        fail(res) {}
      });
    },
    // 更新发货点状态
    updateWareHouse() {
      let self = this;
      self.btnLoading = true;
      let form = Object.assign({}, self.form);
      // form.areaCode = form.areaCode.pop();
      form.areaCode = form.areaCode[2]
      $http.PUT({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminIntegralExchange/UpdateDelivery",
        data: form,
        success(res) {
          self.$message({
            message: "修改成功",
            type: "success"
          });
          self.btnLoading = false;
          self.showAddBox = false;
          self.toSearch();
        },
        fail(res) {
          self.btnLoading = false;
        }
      });
    },
    // 点击删除
    deleteDelivery(id) {
      let self = this;
      this.$confirm("此操作将永久删除该客户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $http.DELETE({
            url:
              this.$store.state.apiUrl +
              "/api/services/app/AdminIntegralExchange/DeleteDelivery",
            params: { deliverypointID: id },
            success(res) {
              self.$message({
                message: "操作成功",
                type: "success"
              });
              self.toSearch();
            },
            fail(res) {}
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 点击编辑按钮
    toEditDepot(row) {
      // console.log(row)
      this.dialogTitle = "编辑发货点:";
      this.iscreat = false;
      this.getWarehouseDetails({ deliverypointID: row.deliveryPointID });
    },
    // 获取列表详情
    getWarehouseDetails(params) {
      let self = this;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminIntegralExchange/GetUpDelivery",
        params: params,
        success(res) {
          // console.log(res);
          if (!res) {
            return;
          }
          // return
          let areaCode = [];
          areaCode.push(Number(res[0].provinceCode));
          areaCode.push(Number(res[0].cityCode));
          areaCode.push(Number(res[0].areaCode));
          // console.log(areaCode);
          // console.log(Object.assign({}, res, {areaCode: areaCode}))
          self.showAddBox = true;
          self.form = Object.assign({}, res[0], { areaCode: areaCode });
          // console.log(self.form);
          // self.$refs.reginTree.setCheckedKeys([]);
          self.defaultKeys = areaCode;
          self.divisionID = res[0].divisionID
          let userID = []
          if(res[0].deliveryPointUser.length) {
            res[0].deliveryPointUser.forEach((item) => {
              userID.push(item.userID)
            })
          }
          self.$set(self.form, 'userID', userID)
          console.log(self.form)
          // self.$forceUpdate();
          // console.log(self.form, self.defaultKeys)
        },
        fail(res) {
          // self.loading = false;
        }
      });
    },
    // 检查表格数据
    checkForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // console.log(this.form);
          if (this.iscreat) {
            this.createWareHouse();
          } else {
            this.updateWareHouse();
          }
        } else {
          // console.log(this.form);
          this.$message({
            showClose: true,
            message: "请正确填写必填项！",
            type: "warning"
          });
          return false;
        }
      });
    },
    // 点击添加按钮
    toAddDepot() {
      this.dialogTitle = "添加发货点:";
      this.showAddBox = !this.showAddBox;
      this.iscreat = true;
      this.divisionID = 0
    },
    // 创建发货点
    createWareHouse() {
      let self = this;
      self.btnLoading = true;
      let form = Object.assign({}, self.form);
      // console.log(form, this.form);
      // form.areaCode = form.areaCode.pop();
      form.areaCode = form.areaCode[2]
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminIntegralExchange/CreateDelivery",
        data: form,
        success(res) {
          self.$message({
            message: "添加成功",
            type: "success"
          });
          self.btnLoading = false;
          self.showAddBox = false;
          self.toSearch();
        },
        fail(res) {
          self.btnLoading = false;
        }
      });
    },
    // 获取用户列表
    getAdminUserList() {
      let self = this;
      self.userListLoading = false;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminUser/GetAdminUserList",
        // params: params,
        success(res) {
          // console.log(res);
          self.userList = res;
          self.userListLoading = false;
        },
        fail(res) {
          self.userListLoading = false;
        }
      });
    },
    // 获取物流公司
    getAllLogistics(params) {
      let self = this;
      self.areaLoading = false;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminLogistics/GetAllLogistics",
        params: params,
        success(res) {
          // console.log(res);
          self.logistics = res;
          self.areaLoading = false;
        },
        fail(res) {
          self.areaLoading = false;
        }
      });
    },
    //获取所有省市区数据
    getAllRegin() {
      let self = this;
      self.regionLoading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl + "/api/services/app/Province/GetAllRegion",
        success(res) {
          // console.log(res);
          self.reginData = res;
          self.regionLoading = false;
          // self.btnLoading = false;
          // console.log(self.areaCode)
        },
        fail(res) {
          self.regionLoading = false;
          // self.btnLoading = false;
        }
      });
    },
    // 获取发货点数据
    getWareHouseList(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminIntegralExchange/GetDeliveryList",
        params: params,
        success(res) {
          console.log(res);
          self.depotList = res;
          // self.totalCount = res.totalCount;
          if(res.length) {
            self.isAdmin = res[0].divisionID
          }
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    // 搜索
    toSearch() {
      // let val = this.status
      // if(val == 2) {
      //   val = ''
      // }
      // let params = {
      //   Status: val,
      //   Keyword: this.searchWord,
      //   MaxResultCount: this.pageSize
      // };
      this.getWareHouseList();
    },
    // 表格checkbox
    handleSelectionChange(val) {
      this.selections = val;
    },
    // 批量启、禁用
    toggleSelection(status) {
      // console.log(this.selections)
      let slectItem = [];
      this.selections.forEach(item => {
        slectItem.push(item.houseID);
      });
      this.enableWarehouse({ houseIDs: slectItem, active: status });
    },
    //一页显示多少个
    handleSizeChange(val) {
      this.pageSize = val;
      let params = {
        MaxResultCount: val,
        Status: this.status,
        Keyword: this.searchWord
      };
      this.getWareHouseList(params);
    },
    //跳转到指定页
    handleCurrentChange(val) {
      // this.loading = true;
      let skipCount = (val - 1) * this.pageSize;
      let params = {
        SkipCount: skipCount,
        MaxResultCount: this.pageSize,
        Status: this.status,
        Keyword: this.searchWord
      };
      this.getWareHouseList(params);
    }
  },
  filters: {
    statusFilter(status) {
      return status ? "已启用" : "已禁用";
    }
  },
  created() {
    this.getWareHouseList({
      // MaxResultCount: this.pageSize
    });
  },
  mounted() {
    this.getAdminUserList();
    // this.getAllLogistics();
    this.getAllRegin();
    // this.getWarehouseDetails({houseid: 6})
    // this.enableWarehouse({houseid: 1, active: 0},{houseid: 2, active: 0},{houseid: 3, active: 0})
  }
};
</script>
<style lang="scss" scoped>
.depot {
  // 搜索
  .seach-box {
    border: 1px solid rgba(228, 228, 228, 1);
    margin: 20px 50px;
    .title {
      display: flex;
      align-items: center;
      height: 50px;
      font-weight: 400;
      background-color: rgba(243, 243, 243, 1);
      border-bottom: 1px solid rgba(228, 228, 228, 1);
      padding-left: 20px;
      // i:first-child {
      //   width: 18px;
      //   height: 18px;
      //   background: green;
      // }
    }
    .input-wrapper {
      display: flex;
      align-items: center;
      height: 60px;
      padding-left: 40px;
      .el-search {
        width: 180px;
      }
      .status {
        margin-left: 40px;
        margin-right: 40px;
      }
    }
  }

  // 发货点列表
  .depot-list {
    margin: 50px 50px 0;
    border: 1px solid rgba(228, 228, 228, 1);
    font-weight: 400;
    .head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: rgba(243, 243, 243, 1);
      border-bottom: 1px solid rgba(228, 228, 228, 1);
      .title {
        display: flex;
        align-items: center;
        height: 50px;
        font-weight: 400;
        padding-left: 20px;
        // i:first-child {
        //   width: 18px;
        //   height: 18px;
        //   background: green;
        // }
      }
    }
    .control {
      .tip-box {
        width: 80px;
        padding-left: 0;
        padding-right: 0;
        margin-right: 20px;
      }
      .select-box {
        width: 100px;
        margin-left: 20px;
      }
    }
    // 弹出框
    .add-box {
      // width: 600px;
      // /deep/ .el-dialog__header {
      //   display: flex;
      //   align-items: center;
      //   padding-top: 14px;
      //   background: rgba(242, 242, 242, 1);
      //   font-weight: 700;
      // }
      .from-el {
        width: 600px;
      }
      .input-el {
        width: 450px;
      }
    }
  }
  .pagination-wrapper {
    text-align: center;
    margin-top: 20px;
  }
}
</style>